import _cloneDeep from 'lodash/cloneDeep';

/**
 * ErrorsService class.
 * Use this service to manage errors configuration, like translations, error messages etc.
 */
export default class ErrorsService {
    /**
     * @param {RemoteConfigService} RemoteConfigService - Service to get configuration from API/server
     * @constructor
     * @ngInject
     */
    constructor(RemoteConfigService) {
        this.RemoteConfigService = RemoteConfigService;

        this.config = _cloneDeep(this.RemoteConfigService.getErrorsConfig());
        if (!this.config) {
            this.config = {};
        }
    }

    /**
     * Get generic errors config
     * @returns {Array} Return list of generic error configs
     */
    getGenericErrors() {
        return this.config.generic || [];
    }

    /**
     * Get error configs by component name
     * @param {string} componentName - Component name
     * @returns {Object|Array<Object>} Return component error configs
     */
    getComponentErrors(componentName) {
        return this.config[componentName] || {};
    }
}



// WEBPACK FOOTER //
// ./app/services/errors/errors.service.js